<template>

<list-view class="main content-pages" :searchTerm="filters.search_term" :paging="paging" :definition="definition" :list="pages" @search="getList($event)" @updatePage="goToPage($event)" @getDetail="$router.push('/website/content-pages/' + $event)" v-if="!loading">
	<template v-slot:filters>
		<div class="filters">
			<div class="title">Filter Pages by published/unpublished and page type...</div>

			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.published ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('published')"></span>
						<label>Published</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.unpublished ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('unpublished')"></span>
						<label>Unpublished</label>
				</li>
			</ul>
			<div class="divider"></div>
			<select v-model="filters.page_type_id" @change="getList()">
				<option value="">Page Type</option>
				<option v-for="(pageType, index) in pageTypeIDList" :value="index">{{ pageType.description }}</option>
			</select>

			<div :class="['button', hasFilters ? 'neutral' : 'disabled' ]" @click="clearFilters(true)">Clear Filters</div>

			<router-link class="button action" to="/website/content-pages/new" tag="div"><span>Add Content Page</span></router-link>
		</div>

		<help-popup :helpLink="{74:'Content Pages', 75:'Menus'}" :tours="false"></help-popup>

	</template>


</list-view>

<loading class="full-page" v-else></loading>
</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: '',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
			loading: false,
			showFilters: true,
			filters: {
				page: 1,
				search_term: '',
				page_type_id: '',
				published: true,
				unpublished: null
			},
			paging: {},
			pages: [],
			definition: [],
			pageTypeIDList: []
		}
	},
	mounted() {
    	this.getList()
	},
	computed: {
		hasFilters() {
			let filterIsSet = false
			for (var property in this.filters) {
				switch (property) {
					case 'hostname':
					case 'page':
					case 'source':
					case 'shopping_cart_id':
						break
					default:
						filterIsSet = this.filters[property] && this.filters[property] != ''
						break
				}
				if (filterIsSet) {
					return true
				}
			}
			return false
		}
	},
	methods: {
		getList(search_term) {
			if (search_term) {
				this.filters.search_term = search_term
			}
            this.loading = true
			this.apiCall({ destination: 'get_list_pages', data: this.filters }).then(obj => {
				this.loading = false
				if (obj.pages) {
					this.pages = obj.pages
					this.paging = obj.paging
					this.definition = obj.definition
					this.pageTypeIDList = obj.page_type_id_list
				}
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		getDetail(page_id) {
			this.$router.push('/website/content-pages/' + page_id)
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				page_type_id: '',
				published: false,
				unpublished: false
			}
			if (getList) {
				this.getList()
			}
		},
		toggleFilter(which) {
			let currentValue = this.filters[which]
			this.filters.published = ''
			this.filters.unpublished = ''
			this.filters[which] = !currentValue
			this.filters.page = 1
			this.getList()
		}
	}
}
</script>

<style lang="scss">
</style>
